import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import PhoneInput from '../../PhoneInput';
import { useLanguage } from '../../../contexts/LanguageContext';

const ContactCard = ({ title, prefix, contact, errors, onField, defaultCountryCode, namePlaceholder, emailPlaceholder }) => {
  const { t, language } = useLanguage();
  return (
    <div className="rounded-lg border border-border p-3 sm:p-4 space-y-4">
      <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t('fullNamePlaceholder')} *</Label>
          <Input
            value={contact.name}
            onChange={(e) => onField(`${prefix}.name`, e.target.value)}
            placeholder={namePlaceholder}
            className={errors[`${prefix}.name`] ? 'border-red-500' : ''}
          />
          {errors[`${prefix}.name`] && <p className="text-xs text-red-500">{errors[`${prefix}.name`]}</p>}
        </div>
        <PhoneInput
          label={t('phone')}
          value={contact.phone}
          onChange={(val) => onField(`${prefix}.phone`, val)}
          defaultCountryCode={defaultCountryCode}
          required
          error={errors[`${prefix}.phone`]}
        />
      </div>
      <div className="space-y-2">
        <Label>{t('email')} ({language === 'en' ? 'optional' : 'optionnel'})</Label>
        <Input
          type="email"
          value={contact.email}
          onChange={(e) => onField(`${prefix}.email`, e.target.value)}
          placeholder={emailPlaceholder}
          className={errors[`${prefix}.email`] ? 'border-red-500' : ''}
        />
        {errors[`${prefix}.email`] && <p className="text-xs text-red-500">{errors[`${prefix}.email`]}</p>}
      </div>
    </div>
  );
};

/** Étape 2 — expéditeur et destinataire. */
const ContactsStep = ({ form, errors = {}, onField }) => {
  const { language } = useLanguage();

  return (
    <div className="space-y-4">
      <ContactCard
        title={language === 'en' ? 'Sender' : 'Expéditeur'}
        prefix="sender"
        contact={form.sender}
        errors={errors}
        onField={onField}
        defaultCountryCode={form.origin_country || 'FR'}
        namePlaceholder="Jean Dupont"
        emailPlaceholder="jean.dupont@email.com"
      />
      <ContactCard
        title={language === 'en' ? 'Recipient' : 'Destinataire'}
        prefix="recipient"
        contact={form.recipient}
        errors={errors}
        onField={onField}
        defaultCountryCode={form.destination_country || 'CM'}
        namePlaceholder="Paul Martin"
        emailPlaceholder="paul.martin@email.com"
      />
    </div>
  );
};

export default ContactsStep;
